import React from "react";
import { cn } from "@/lib/utils";

// Barre de progression fine de 3px, animée vers sa nouvelle largeur en 420ms.
export const ProgressBar = ({ value = 0, max = 100, className, dataTestId = "progress-bar" }) => {
    const pct = Math.max(0, Math.min(100, (value / max) * 100));
    return (
        <div
            data-testid={dataTestId}
            role="progressbar"
            aria-valuenow={value}
            aria-valuemin={0}
            aria-valuemax={max}
            className={cn("w-full rounded-full overflow-hidden", className)}
            style={{ height: "3px", backgroundColor: "var(--border)" }}
        >
            <div
                className="h-full rounded-full"
                style={{
                    width: `${pct}%`,
                    backgroundColor: "var(--red)",
                    transition: "width var(--dur-screen) var(--ease)",
                }}
            />
        </div>
    );
};
